import { useState } from "react";

export default function ProductGallery({ images = [], productName, children }) {
  const [activeIndex, setActiveIndex] = useState(0);
  const active = images[activeIndex] || images[0];

  if (!active) return null;

  const shouldContain = active.fit === "contain";
  const mainImageFit = shouldContain ? "sn-object-contain" : active.source === "SNB/client asset audit" ? "sn-object-cover" : "sn-object-contain";
  const mainImageBackground = shouldContain ? "sn-bg-sage" : "sn-bg-white";
  const mainImageStyle = active.position ? { objectPosition: active.position } : undefined;

  return (
    <div className="sn-grid sn-w-full sn-min-w-0 sn-gap-6 lg:sn-grid-cols-[0.48fr_0.52fr] lg:sn-items-start lg:sn-gap-12">
      <div className="sn-w-full sn-min-w-0">
        <div className={`sn-w-full sn-min-w-0 sn-overflow-hidden sn-rounded-card sn-border sn-border-line lg:sn-h-[360px] xl:sn-h-[380px] ${mainImageBackground}`}>
          <img
            src={active.src}
            alt={active.alt || productName}
            width="900"
            height="700"
            className={`sn-h-auto sn-w-full sn-max-w-full sn-object-center lg:sn-h-full ${mainImageFit}`}
            style={mainImageStyle}
          />
        </div>

        {images.length > 1 && (
          <div className="sn-mt-3 sn-grid sn-w-full sn-min-w-0 sn-grid-cols-4 sn-gap-2" aria-label={`${productName} image gallery`}>
            {images.map((image, index) => (
              <button
                key={`${image.alt}-${index}`}
                type="button"
                onClick={() => setActiveIndex(index)}
                aria-label={`Show ${productName} image ${index + 1}`}
                aria-pressed={activeIndex === index}
                className={`sn-min-w-0 sn-overflow-hidden sn-rounded sn-border sn-bg-white sn-p-1 ${activeIndex === index ? "sn-border-forest" : "sn-border-line"}`}
              >
                <img
                  src={image.src}
                  alt=""
                  loading="lazy"
                  className="sn-aspect-square sn-h-auto sn-w-full sn-max-w-full sn-object-cover"
                />
              </button>
            ))}
          </div>
        )}
      </div>

      {children}
    </div>
  );
}
